module.exports = __webpack_public_path__ + "static/2021-03-10-12-54-01-328-fs8-fs8-a8267edb16565ec937a76a783d6368f2.png";